<script setup lang="ts">
import { useAttrs } from 'vue'
import { cx } from './cx'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  class?: string
  modelValue?: string
}>()

const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const attrs = useAttrs()

function onInput(e: Event) {
  emit('update:modelValue', (e.target as HTMLTextAreaElement).value)
}
</script>

<template>
  <textarea
    v-bind="attrs"
    :value="modelValue"
    :class="cx('field text-[14px] leading-relaxed', props.class)"
    @input="onInput"
  />
</template>
